import { useNavigate } from "react-router-dom";
import React from "react";
import { Breadcrumb, Button } from "antd";
import { Link } from "react-router-dom";
import "../styles/breadcrumbs.css";
import Home from "../../assets/images/vectors/HomeIcon";

const CommonBreadcrumb = ({ breadcrumbItems, children, rightButton }) => {
  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const role_value = userData?.role_value;
  const handleClick = () => {
    if ([1, 2, 3].includes(role_value)) {
      navigate("/site");
    } else if ([4, 5, 6, 7, 8, 9].includes(role_value)) {
      navigate("/site");
    } else if ([10, 11, 12].includes(role_value)) {
      return;
    } else {
      navigate("/");
    }
  };

  return (
    <div
      className={`flex items-center h-14 ${
        children || rightButton ? "overflow-x-auto" : ""
      } space-x-8 ${
        breadcrumbItems?.length > 0 ? "justify-between" : "justify-end"
      }`}
    >
      {breadcrumbItems?.length > 0 && (
        <Breadcrumb
          className="mt-4 flex-shrink-0"
          separator={
            <span className="font-bold rotate-90 inline-block "> | </span>
          }
        >
          <span onClick={handleClick} className="cursor-pointer">
            <Home className="home-icon" />
          </span>
          <span className="font-medium text-[#000000] rotate-90 inline-block mx-3.5">
            {" "}
            |{" "}
          </span>
          {breadcrumbItems.map((item, index) => (
            <Breadcrumb.Item key={index}>
              <Link to={item.href} className="breadcrumb-link">
                {item.label}
              </Link>
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      )}
      <div className="flex items-center space-x-4 whitespace-nowrap">
        {children}
        {rightButton && (
          <Button
            type="primary"
            icon={rightButton.icon} // ✅ now icon supported
            onClick={rightButton.onClick}
            className="mr-1  h-[30px] font-medium"
          >
            {rightButton.label}
          </Button>
        )}
      </div>
    </div>
  );
};

export default CommonBreadcrumb;
